// src/hooks/useChat.js
//
// Chat v2: real-time subscription to a single chat doc. Used by
// the chat detail page to render the header (chat name, member
// count, photo) and to check whether the user is allowed to post
// (admin role for team_announcement channels).

import { useEffect, useState } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '@/firebase/firebase'

export default function useChat(chatId) {
  const [chat, setChat] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!chatId) {
      setChat(null)
      setLoading(false)
      return
    }
    setLoading(true)

    const unsub = onSnapshot(
      doc(db, 'chats', chatId),
      (snap) => {
        if (!snap.exists()) {
          // Chat doesn't exist or user lacks read access. Both
          // produce the same UX (404-ish empty state).
          setChat(null)
          setError('not-found')
        } else {
          setChat({ id: snap.id, ...snap.data() })
          setError(null)
        }
        setLoading(false)
      },
      (err) => {
        // Permission-denied is the most common cause: user not in
        // participantIds. Treat as not-found from the user's POV.
        console.warn('[useChat] snapshot error:', err?.code, err?.message)
        setChat(null)
        setError(err?.code === 'permission-denied' ? 'not-found' : (err?.message || 'chat-failed'))
        setLoading(false)
      },
    )
    return () => unsub()
  }, [chatId])

  return { chat, loading, error }
}
